import React from 'react';

/**
 * StatTooltip - Reusable rich tooltip content for Statistic cards.
 *
 * Usage:
 *   <Tooltip title={<StatTooltip title="Resumo" rows={[...]} />} placement="bottom">
 *
 * @param {Object} props
 * @param {string} props.title - Tooltip header text
 * @param {Array} props.rows - Array of { label, value, color, bold, borderTop }
 * @param {string} props.description - Optional footer description text
 */
var StatTooltip = function(props) {
  var title = props.title;
  var rows = props.rows || [];
  var description = props.description;

  return React.createElement('div', { style: { minWidth: '200px', fontSize: '12px' } },
    title && React.createElement('div', {
      style: { fontWeight: 700, fontSize: '12px', marginBottom: '6px', color: '#fff', letterSpacing: '0.02em' }
    }, title),
    rows.map(function(row, index) {
      return React.createElement('div', {
        key: index,
        style: {
          display: 'flex', justifyContent: 'space-between', gap: '16px',
          padding: '3px 0',
          fontWeight: row.bold ? 600 : 400,
          borderTop: row.borderTop ? '1px solid rgba(255,255,255,0.15)' : 'none',
          marginTop: row.borderTop ? '4px' : 0,
          paddingTop: row.borderTop ? '6px' : '3px'
        }
      },
        React.createElement('span', { style: { color: 'rgba(255,255,255,0.7)' } }, row.label),
        React.createElement('span', { style: { color: row.color || '#fff' } }, row.value)
      );
    }),
    description && React.createElement('div', {
      style: { marginTop: '8px', color: 'rgba(255,255,255,0.6)', fontSize: '11px', lineHeight: '1.4' }
    }, description)
  );
};

export default StatTooltip;
